import React from 'react';
import { Block } from '@mui/icons-material';
import photo1 from "../img/photo/photo1.png";

const Photo = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Photo type</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--single-vertical">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={photo1} alt="Photo quality issue example" onClick={() => onImageClick && onImageClick(photo1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Double selfie
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </>
  );
};

export default Photo;